import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import { action } from '@ember/object';
import { run } from '@ember/runloop';
import CustomerModel from 'cio/models/customer';
import IndexController from './controller';
import PeopleListController from '../controller';
import Transition from '@ember/routing/-private/transition';
import DS from 'ember-data';

export default class PeopleListIndexRoute extends Route {
  @service store!: DS.Store;

  queryParams = {
    email: {
      refreshModel: true,
    },
    filters: {
      refreshModel: true,
    },
    page: {
      refreshModel: true,
    },
  };

  beforeModel() {
    // https://github.com/emberjs/data/issues/5447#issuecomment-845672812
    // unloadAll is broken and doesn't entirely remove records properly.
    // The advice in the comment is to wrap it in run, to force the destroy
    // runloop to finish, but that doesn't seem to fix some issues in our app.
    // Calling unloadRecord individually and wrapping that in a run call does
    // seem to work better for us.
    run(() => this.store.peekAll('customer').forEach((c) => c.unloadRecord()));
  }

  model(params: Record<string, string>) {
    return this.store.query('customer', {
      ...params,
      sort: 'created_at',
      asc: false,
    });
  }

  setupController(controller: IndexController, model: CustomerModel[], transition: Transition) {
    super.setupController(controller, model, transition);

    controller.setProperties({
      selectedPeople: [],
      _allSelected: false,
      totalRecs: model.get('meta.pagination.total' as any),
      shiftSelectStart: null,
      shiftSelectEnd: null,
    });

    let listController = this.controllerFor('people.list') as PeopleListController;

    let email = controller.get('email');

    let message = model.get('meta.message' as any);
    let filters = controller.get('filters');
    let activeSearchBy = listController.get('activeSearchBy');
    let searchByFilter = filters && !listController.emptyFilters;
    if (searchByFilter) {
      activeSearchBy = 'filter';
    }

    listController.setProperties({
      searchInput: email,
      totalRecs: model.get('meta.pagination.total' as any),
      people: model,
      activeSearchBy,
      message,
    });
    listController.trackViewSearchFilter();

    controller.set('source', null);
  }

  @action
  reloadModel() {
    this.refresh();
  }
}
